import React from 'react';
import { ProcessingProgress } from 'types/lovDataTypes';

interface LOVLoadingIndicatorProps {
  isLoading?: boolean;
  isProcessing?: boolean;
  processingProgress?: ProcessingProgress;
  error?: string | null;
  title?: string;
  height?: string;
  className?: string;
  overlay?: boolean;
}

const LOVLoadingIndicator: React.FC<LOVLoadingIndicatorProps> = ({
  isLoading = false,
  isProcessing = false,
  processingProgress,
  error = null,
  title,
  height = '200px',
  className = '',
  overlay = false
}) => {
  if (error) {
    return (
      <div className={`d-flex justify-content-center align-items-center ${className} ${overlay ? 'overlay' : ''}`} style={{ height }}>
        <div className="alert alert-danger" role="alert">
          <i className="ri-error-warning-line me-2"></i>
          Error loading options: {error}
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={`d-flex justify-content-center align-items-center ${className} ${overlay ? 'overlay' : ''}`} style={{ height }}>
        <div className="d-flex align-items-center">
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <span>{title || 'Fetching options from server...'}</span>
        </div>
      </div>
    );
  }

  if (isProcessing) {
    return (
      <div className={`d-flex justify-content-center align-items-center ${className} ${overlay ? 'overlay' : ''}`} style={{ height }}>
        <div className="d-flex align-items-center">
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Processing...</span>
          </div>
          <div>
            <span>{title || 'Processing options...'}</span>
            {processingProgress && processingProgress.total > 0 && (
              <div className="progress mt-1" style={{ height: '4px' }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${processingProgress.percentage}%` }}
                  aria-valuenow={processingProgress.percentage}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default LOVLoadingIndicator; 